import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SaveIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon viewboxSize="xl" {...props}>
    <path d="M21 19C21 21.7614 18.7614 24 16 24C13.2386 24 11 21.7614 11 19C11 16.2386 13.2386 14 16 14C18.7614 14 21 16.2386 21 19ZM19 19C19 17.3431 17.6569 16 16 16C14.3431 16 13 17.3431 13 19C13 20.6569 14.3431 22 16 22C17.6569 22 19 20.6569 19 19Z" />
    <path d="M7 4C5.89543 4 5 4.89543 5 6V26C5 27.1046 5.89543 28 7 28H25C26.1046 28 27 27.1046 27 26V10.8284C27 10.298 26.7893 9.78929 26.4142 9.41421L21.5858 4.58579C21.2107 4.21071 20.702 4 20.1716 4H7ZM7 6L11 6V10C11 11.1046 11.8954 12 13 12H19C20.1046 12 21 11.1046 21 10V6.82843L25 10.8284V26H7L7 6ZM13 6H19V10H13V6Z" />
  </BaseIcon>
);
